import React from 'react';
import { GeckoIcon, GeckoRow, GeckoCol } from '@geckolabs/gecko-react-ui';
import Spinner from '../../Spinner';
import RsvpService from '../../../services/RsvpService';
import { __, STR_KEY } from '../../../services/Translate';
import HtmlWrapper from '../../HtmlWrapper';
import Hosts from '../../Hosts';
import SessionTime from '../../SessionTime';
import Utils from '../../../services/utils/utils';
import GeckoStore from '../../../services/GeckoStore';

export function SessionClosedAlert() {
    return (
        <GeckoRow>
            <GeckoCol width="12">
               <div role="alert" className="status-control-alert alert alert-info">
                    <i className="far fa-info-circle"></i>
                    <span>{__(STR_KEY.PROFILE_SESSION_ALERT_CLOSED)}</span>
                </div>
            </GeckoCol>
        </GeckoRow>
    );
};

export function Description({description}) {
    if(!description || !(description).replace(/(<([^>]+)>)/ig,'')) return null;
    
    return (
        <div className="sessionDescription section">
            <div className="row">
                <div className="col sectionLabel" role="heading" aria-level="2">
                    {__(STR_KEY.MODAL_SESSION_TITLE_ABOUT)}
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <HtmlWrapper html={description} />
                </div>
            </div>
        </div>
    )
}

export function Tags({tags}) {
    if (!tags) return null;

    const parsedTags = JSON.parse(tags);

    if (!Array.isArray(parsedTags) || !parsedTags.length) return null;

    return (
        <div className="row d-flex flex-wrap section">
            <div className="col sessionTags ">
                <i className="fa fa-tags"></i>
                {parsedTags.map((tag, key) => {
                    return (
                        <span key={key} className="sessionTag">
                            #{tag}
                        </span>
                    );
                })}
            </div>
        </div>
    );  
}

export function HostsWrapper({hosts=[]}) {
    if (!hosts.length) return null;

    return (
        <div className="sessionHosts section">  
            <Hosts hosts={hosts} />
        </div>
    );
}

export function BackButton({handler}){
    if (!handler) return null;

    return (
        <button className="backModal" aria-label="Back to sessions" onClick={() => {
            handler();
        }}>
            <GeckoIcon icon="arrow-left" />
        </button>
    );
}

export function DeliveryMethod({session}) {
    if (!session) return null;

    const [str, icon] = RsvpService.getPrettyDeliveryMethod(session, true);
    return (
        <div>
            <i className={icon}></i>
            &nbsp;
            {str}
        </div>
    );
}

export function Loader() {
    return (
        <div className="d-flex justify-content-center loaderContainer">
            <Spinner />
        </div>
    );
}

export function TitleCard({session, times}) {
    if (!session || !Object.keys(times || {}).length) return null;

    return (
        <div className="titleCard card materialCard">
            <div className="row">
                <SessionTime start={times.start} end={times.end} className="col-lg-4" />

                <div className="col-7 col-lg-8 flex-column d-flex justify-content-center sessionTitleColumn">
                    <div className="sessionInfo">
                        <h1 className="sessionTitle" id="sessionTitle">
                            {session.title}
                        </h1>
                        <DeliveryMethod session={session} />
                    </div>
                </div>
            </div>
        </div>
    );
}


export function NoTimesAvailable() {
    return (
        <div className="status-control-alert alert alert-info">
            <div className="row">
                <div className="col">
                    {__(STR_KEY.MODAL_SESSION_ALERT_TIMES_FALLBACK)}
                </div>
            </div>
        </div>
    )
};

export function Header({session, event, backButtonHandler, closeModalHandler}) {
    if (!session) return null;

    const styles = ((session={}, event={}) => {
        const account = GeckoStore.redux.get('account');
        const image = session.image || event.image || account.header_bg;
        const color = session.color || event.color || account.color;
        return {
            banner: {
                backgroundImage: `url(${Utils.appendSizeToImageUrl(image, 600)})`, 
                backgroundColor: `${!image ? color : null}`
            },
            displayGradient: {
                background: image ? `${color}b3` : null
            },
        };
    })(session, event);
    let ti = {tabIndex: 0};

    return (
        <div className="sessionHeader" style={styles.banner}>
            <div className={'gradientOverlay'} style={styles.displayGradient}>
                <div className="row no-gutters controlsRow">
                    <div className="col">
                        <BackButton handler={backButtonHandler} />
                    </div>

                    <div className="col d-flex justify-content-end">
                        <button className="closeModal" onClick={closeModalHandler} {...ti} role="button" aria-label="Close">
                            <GeckoIcon icon="times" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default {
    SessionClosedAlert,
    Description,
    Tags,
    HostsWrapper,
    BackButton,
    DeliveryMethod,
    Loader,
    TitleCard,
    NoTimesAvailable,
    Header
}